// The Rails CSRF token from the page's meta tag, for JSON requests that change
// state. Empty when the tag is missing, so the server answers with its own
// error instead of the page throwing.
export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ''
}
